/**
 * Floating Container Component
 * For modals, dropdowns, etc.
 *
 * NOTE: Render nothing in schematic preview mode because interactive
 * floating elements obstruct the view and cannot be interacted with.
 */
const Floating = () => null;

export default Floating;
